export default import.meta.ROLLDOWN_FILE_URL_IIbQ5w_tU2ENF4MI12kVqg